const ROUTE_SESSION_STATUS = {
    ACTIVE: 'active',
    CLOSED: 'closed',
    INACTIVE: 'inactive',
    PREPARING_LOAD: 'preparing_load',
    AWAITING_PICKUP: 'awaiting_pickup',
    IN_TRANSIT: 'in_transit',
    AWAITING_DROPOFF: 'awaiting_dropoff',
    MANUAL_ADJUSTMENT: 'manual_adjustment',
    CANCELLED: 'cancelled',
    AWAITING_OFFLOAD: 'awaiting_offload',
    // Prettier No Prettying
};

export const processedFluidRouteSessionStatuses = [
    { name: 'Active', value: 'active' },
    { name: 'Closed', value: 'closed' },
    { name: 'Awaiting Offload', value: 'inactive' },
    { name: 'Preparing Load', value: 'preparing_load' },
    { name: 'Awaiting Pickup', value: 'awaiting_pickup' },
    { name: 'In Transit', value: 'in_transit' },
    { name: 'Awaiting Dropoff', value: 'awaiting_dropoff' },
    { name: 'Manual Adjustment', value: 'manual_adjustment' },
    { name: 'Cancelled', value: 'cancelled' },
];

export default ROUTE_SESSION_STATUS;
